import { render, staticRenderFns } from "./CertificateListB2B.vue?vue&type=template&id=b740829a"
import script from "./CertificateListB2B.vue?vue&type=script&lang=js"
export * from "./CertificateListB2B.vue?vue&type=script&lang=js"
import style0 from "./CertificateListB2B.vue?vue&type=style&index=0&id=b740829a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports